import * as S from "./TabItem.style";

interface TabItemProps {
  data?: any;
  onClick?: (e: any) => void;
  currentTab: string;
}

export const TabItem = ({ data, currentTab, onClick }: TabItemProps) => {
  return (
    <S.TabItem onClick={onClick}>
      <S.TabItemTit $active={currentTab === data.id ? true : false}>
        {data.title}
      </S.TabItemTit>
    </S.TabItem>
  );
};
